import React from 'react';
import { textblocks } from 'seal-ui-components';
import styled from 'styled-components';
import style from './Divider.style';

const Divider = ({ className, ...rest }) => (
    <textblocks.HorizontalRule {...rest} className={className} />
);

export default styled(Divider)`
    ${style};
`;
